/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useState } from "react";
import fetchHelper from "../../services/fetchHelper";
import cn from "classnames";
import { LayoutContext } from "../../components/layout";

export const CsCheckBoxItem = ({ item, interrogationStats, setInterrogationStats }) => {
  const { headerDetails: userInfo } = useContext(LayoutContext);
  const [isChecked, setIsChecked] = useState(item.interrogationStatements[0].isused);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const showStatus = (status) => {
    setIsSuccess(status);
    setTimeout(() => {
      setIsSuccess(null);
    }, 3000);
  };

  const checkIsUsed = async (esignId, isusedValue) => {
    return await fetchHelper.put("/patientmanagement/rest/interrogationstatement/update", {
      eSignStatement: { id: esignId },
      interrogation: { id: userInfo.id },
      isused: isusedValue,
    });
  };

  const updateInterrogationStatement = (updatedStatement) => {
    const newInterrogationsStat = interrogationStats.map((interrogation) => {
      interrogation.esignStatements = interrogation.esignStatements.map((statement) => {
        if (statement.interrogationStatements[0].id === item.interrogationStatements[0].id) {
          statement.isused = updatedStatement.isused;
          statement.interrogationStatements[0].isused = updatedStatement.isused;
        }
        return statement;
      });
      return interrogation;
    });

    setInterrogationStats(newInterrogationsStat);
  };

  const updateData = async (checked) => {
    if (isLoading) {
      return;
    }

    setIsChecked(checked);
    setIsSuccess(null);
    setIsLoading(true);
    try {
      const updatedStatement = await checkIsUsed(item.id, checked);
      updateInterrogationStatement(updatedStatement);
      showStatus(true);
    } catch (err) {
      console.error(err);
      showStatus(false);
      setIsChecked(!checked);
    } finally {
      setIsLoading(false);
    }
  };

  if (!item.conclusionStatement || item.conclusionStatement === "") return null;

  return (
    <div>
      <div
        style={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          position: "relative",
          flexWrap: "wrap",
          backgroundColor: "transparent",
        }}
        className="checkbox-container"
      >
        <label
          className="form-li"
          style={{
            flex: 1,
            marginBottom: 3,
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            className="chk"
            disabled={isLoading}
            checked={isChecked}
            onChange={(e) => updateData(e.target.checked)}
          />
          <span className="chkmrk" />
          <span className="lbl-txt" style={{ display: "flex", flex: 1 }}>
            {item.conclusionStatement}
          </span>
        </label>
        {isLoading ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
          />
        ) : null}
        {isLoading ? (
          <div className="saving-teal-ico icon-64" style={{ marginLeft: 5, marginRight: 15 }} />
        ) : null}
        {isSuccess != null && !isLoading ? (
          <div
            className={cn({ "check-ico": isSuccess }, { "close-ico": !isSuccess }, "icon-64")}
            style={{ marginLeft: 5, marginRight: 5 }}
          />
        ) : null}
      </div>
    </div>
  );
};
